<div class="notification-dropdown">
  <!-- Bell icon with badge -->
  <div class="notification-bell-wrapper">
    <button
      type="button"
      class="notification-bell p-link"
      (click)="op.toggle($event)"
    >
      <i *ngIf="unreadCount > 0" class="pi pi-bell" style="font-size: 1.5rem" pBadge [value]="unreadCount > 0 ? unreadCount.toString() : ''" severity="danger"></i>
      <i *ngIf="unreadCount === 0" class="pi pi-bell" style="font-size: 1.5rem"></i>
    </button>
  </div>

  <!-- Popover (dropdown) -->
  <p-popover #op [style]="{ width: '400px' }" styleClass="notification-overlay">
    <div class="notification-dropdown-content">
      <!-- Header -->
      <div class="dropdown-header">
        <h3 class="dropdown-title">{{ 'notifications.title' | translate }}</h3>
        <p-button
          *ngIf="hasNotifications"
          [label]="'notifications.markAllAsRead' | translate"
          icon="pi pi-check"
          [disabled]="markAllDisabled"
          (onClick)="markAllAsRead(op)"
          styleClass="p-button-text p-button-sm"
        ></p-button>
      </div>

      <!-- Notification list -->
      <div *ngIf="hasNotifications" class="notification-list">
        <app-notification-item
          *ngFor="let notification of recentNotifications"
          [notification]="notification"
          [compact]="true"
          (notificationClick)="onNotificationClick($event, op)"
        ></app-notification-item>
      </div>

      <!-- Empty state -->
      <div *ngIf="!hasNotifications" class="empty-state">
        <i class="pi pi-bell-slash"></i>
        <p>{{ 'notifications.empty' | translate }}</p>
      </div>

      <!-- Footer -->
      <div class="dropdown-footer">
        <p-button
          [label]="'notifications.viewAll' | translate"
          icon="pi pi-arrow-left"
          (onClick)="viewAll(op)"
          styleClass="p-button-text w-full"
        ></p-button>
      </div>
    </div>
  </p-popover>
</div>
